(function () {
    'use strict';

    angular
        .module('elogbooks.admin.site-associations')
        .factory('siteReassignFiltersService', siteReassignFiltersService);

    siteReassignFiltersService.$inject = ['$translate'];

    function siteReassignFiltersService($translate) {
        return {
            create: create,
            getApiParams: getApiParams,
            getStateParams: getStateParams
        };

        function create(rootResourceResponse, $stateParams, collections) {
            var models = createModels(rootResourceResponse, collections || {});
            var statusOptions = [
                { title: $translate.instant('NONE_SELECTED'), value: null },
                { title: $translate.instant('STATUS_ACTIVE'), value: 'active' },
                { title: $translate.instant('STATUS_INACTIVE'), value: 'inactive' }
            ];

            return {
                criteria: {
                    siteIds: {
                        type: 'autocompletemulti',
                        multiple: true,
                        title: 'SITE',
                        value: $stateParams.siteIds && $stateParams.siteIds.length ? $stateParams.siteIds : null,
                        options: models.site,
                        param: 'siteIds',
                        max: 50,
                        isClear: !($stateParams.siteIds && $stateParams.siteIds.length)
                    },
                    regionIds: {
                        type: 'autocompletemulti',
                        multiple: true,
                        title: 'REGION',
                        value: $stateParams.regionIds && $stateParams.regionIds.length ? $stateParams.regionIds : null,
                        options: models.region,
                        param: 'regionIds',
                        max: 50,
                        isClear: !($stateParams.regionIds && $stateParams.regionIds.length)
                    },
                    siteGroup: {
                        type: 'jsonselectwidget',
                        title: 'SITE_GROUP',
                        value: $stateParams.siteGroup ? JSON.parse($stateParams.siteGroup) : null,
                        options: models.siteGroup
                    },
                    coreClient: {
                        type: 'jsonselectwidget',
                        title: 'CORE_CLIENT',
                        value: $stateParams.coreClient ? JSON.parse($stateParams.coreClient) : null,
                        options: models.coreClient
                    },
                    siteStatus: {
                        type: 'options',
                        title: 'SITE_STATUS',
                        value: $stateParams.siteStatus || null,
                        options: statusOptions
                    }
                },
                stateParams: {
                    siteIds: $stateParams.siteIds,
                    regionIds: $stateParams.regionIds,
                    siteGroup: $stateParams.siteGroup,
                    coreClient: $stateParams.coreClient,
                    siteStatus: $stateParams.siteStatus
                }
            };
        }

        function createModels(rootResourceResponse, collections) {
            return {
                site: createMultiFilterModel(rootResourceResponse.getLink('sites'), 'sites', {}),
                region: createMultiFilterModel(rootResourceResponse.getLink('regions'), 'regions', {
                    active: true,
                    order: 'name'
                }),
                siteGroup: createSingleFilterModel(rootResourceResponse.getLink('sitegroups'), 'sitegroups', {
                    active: 'yes',
                    order: 'name'
                }, collections.siteGroup),
                coreClient: createSingleFilterModel(rootResourceResponse.getLink('coreclients'), 'coreclients', {
                    active: 'yes',
                    order: 'name'
                }, collections.coreClient)
            };
        }

        function createMultiFilterModel(link, responseKeyPath, linkParameters) {
            return {
                link: link,
                linkParameters: angular.extend({ order: 'name' }, linkParameters || {}),
                responseKeyPath: responseKeyPath,
                itemValuePath: 'name',
                itemHrefPath: 'id',
                selectedItems: [],
                autocompletemulti: true
            };
        }

        function createSingleFilterModel(link, responseKeyPath, linkParameters, response) {
            return {
                response: response || null,
                link: response && response.getLink('self') ? response.getLink('self') : link,
                linkParameters: angular.extend({ order: 'name' }, linkParameters || {}),
                responseKeyPath: responseKeyPath,
                itemValuePath: 'id',
                itemTitlePath: 'name',
                loadmoreEnabled: true
            };
        }

        function getApiParams(criteriaParams, criteria) {
            criteriaParams = criteriaParams || {};

            var params = {};
            var siteIds = criteriaParams.siteIds !== undefined ? criteriaParams.siteIds : criteria.siteIds.value;
            var regionIds = criteriaParams.regionIds !== undefined ? criteriaParams.regionIds : criteria.regionIds.value;
            var siteGroup = selectedCriteriaId(criteriaParams.siteGroup !== undefined ? criteriaParams.siteGroup : criteria.siteGroup.value);
            var coreClient = selectedCriteriaId(criteriaParams.coreClient !== undefined ? criteriaParams.coreClient : criteria.coreClient.value);
            var siteStatus = criteriaParams.siteStatus !== undefined ? criteriaParams.siteStatus : criteria.siteStatus.value;

            if (siteIds && siteIds.length) {
                params['siteIds[]'] = siteIds.map(function (id) {
                    return parseInt(id, 10);
                });
            }

            if (regionIds && regionIds.length) {
                params['regionIds[]'] = regionIds.map(function (id) {
                    return parseInt(id, 10);
                });
            }

            if (siteGroup) {
                params.siteGroup = siteGroup;
            }

            if (coreClient) {
                params.coreClient = coreClient;
            }

            if (siteStatus) {
                params.siteStatus = siteStatus;
            }

            return params;
        }

        function getStateParams(criteriaParams) {
            criteriaParams = criteriaParams || {};

            return {
                siteIds: criteriaParams.siteIds && criteriaParams.siteIds.length ? criteriaParams.siteIds : null,
                regionIds: criteriaParams.regionIds && criteriaParams.regionIds.length ? criteriaParams.regionIds : null,
                siteGroup: stringifyJsonValue(criteriaParams.siteGroup),
                coreClient: stringifyJsonValue(criteriaParams.coreClient),
                siteStatus: criteriaParams.siteStatus || null
            };
        }

        function selectedCriteriaId(value) {
            value = parseJsonValue(value);

            return value && value.v ? parseInt(value.v, 10) : null;
        }

        function parseJsonValue(value) {
            if (!value) {
                return null;
            }

            return angular.isString(value) ? JSON.parse(value) : value;
        }

        function stringifyJsonValue(value) {
            value = parseJsonValue(value);

            return value ? JSON.stringify(value) : null;
        }
    }
})();
